import { Map } from 'immutable';
import { actionTypes as actionTypes } from '../../../actions/Administration/SettingsPage/Dialogs/createSchedulingTriggerDialogActions';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case actionTypes.CREATE_SCHEDULING_TRIGGER_DIALOG_SHOW:
      return state.set('itemToEdit', action.payload)
        .set('show', true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.CREATE_SCHEDULING_TRIGGER_DIALOG, defaultState);
  }
}
